import React, { useEffect } from "react";
import AppRouter from "./routes/app.router";
import { rehydrateAuthState } from "./features/slices/Auth";
import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "./store";
import { useNavigate, useLocation } from "react-router-dom";
import Loader from "./components/Loader";
import { frontVersionInfo } from "./utils/util";
import versionService from "./services/VersionService";

const AUTH_PAGES = [
  "/signin",
  "/signup",
  "/reset-password",
  "/reset-password/request",
  "/",
];

const App = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const location = useLocation();
  const { rehydrated, isInit } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    dispatch(rehydrateAuthState());
  }, [dispatch]);

  useEffect(() => {
    if (!AUTH_PAGES.includes(location.pathname)) {
      localStorage.setItem("redirectTo", location.pathname);
    }
  }, [location]);

  useEffect(() => {
    if (rehydrated) {
      const redirectTo = localStorage.getItem("redirectTo");
      if (
        redirectTo &&
        !AUTH_PAGES.includes(redirectTo) &&
        location.pathname !== redirectTo
      ) {
        // navigate(redirectTo, { replace: true });
        localStorage.removeItem("redirectTo");
      }
    }
  }, [rehydrated, location]);

  useEffect(() => {
    versionService
      .postVersion(frontVersionInfo)
      .catch((err) => console.error("Failed to register front version", err));
  }, []);

  if (isInit) {
    return <Loader />;
  }

  return <AppRouter />;
};

export default App;
